var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.titel))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text"},on:{"input":function($event){return _vm.$parent.$emit('filter-update', { value: $event.target.value, name: _vm.name })}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }